/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getTumors } from 'app/entities/tumor/tumor.reducer';
import { createEntity, getEntity, reset, updateEntity } from './tumor-staging.reducer';

export const TumorStagingUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const tumors = useAppSelector(state => state.tumor.entities);
  const tumorStagingEntity = useAppSelector(state => state.tumorStaging.entity);
  const loading = useAppSelector(state => state.tumorStaging.loading);
  const updating = useAppSelector(state => state.tumorStaging.updating);
  const updateSuccess = useAppSelector(state => state.tumorStaging.updateSuccess);

  const handleClose = () => {
    navigate(`/tumor-staging${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getTumors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.stagingDate !== undefined && typeof values.stagingDate !== 'number') {
      values.stagingDate = Number(values.stagingDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tumorStagingEntity,
      ...values,
      recordedBy: doctors.find(it => it.id.toString() === values.recordedBy?.toString()),
      tumor: tumors.find(it => it.id.toString() === values.tumor?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...tumorStagingEntity,
          recordedBy: tumorStagingEntity?.recordedBy?.id,
          tumor: tumorStagingEntity?.tumor?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tumorStaging.home.createOrEditLabel" data-cy="TumorStagingCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tumorStaging.home.createOrEditLabel">Create or edit a TumorStaging</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tumor-staging-id"
                  label={translate('tinyMedicRestApp.tumorStaging.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.stage')}
                id="tumor-staging-stage"
                name="stage"
                data-cy="stage"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="stageLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.stage" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.stagingDate')}
                id="tumor-staging-stagingDate"
                name="stagingDate"
                data-cy="stagingDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="stagingDateLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.stagingDate" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.displayId')}
                id="tumor-staging-displayId"
                name="displayId"
                data-cy="displayId"
                type="text"
              />
              <UncontrolledTooltip target="displayIdLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.displayId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.algorithm')}
                id="tumor-staging-algorithm"
                name="algorithm"
                data-cy="algorithm"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="algorithmLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.algorithm" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.version')}
                id="tumor-staging-version"
                name="version"
                data-cy="version"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="versionLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.version" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.title')}
                id="tumor-staging-title"
                name="title"
                data-cy="title"
                type="text"
              />
              <UncontrolledTooltip target="titleLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.title" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.subtitle')}
                id="tumor-staging-subtitle"
                name="subtitle"
                data-cy="subtitle"
                type="text"
              />
              <UncontrolledTooltip target="subtitleLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.subtitle" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.notes')}
                id="tumor-staging-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <UncontrolledTooltip target="notesLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.notes" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.stagingInput')}
                id="tumor-staging-stagingInput"
                name="stagingInput"
                data-cy="stagingInput"
                type="text"
              />
              <UncontrolledTooltip target="stagingInputLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.stagingInput" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.stagingOutcome')}
                id="tumor-staging-stagingOutcome"
                name="stagingOutcome"
                data-cy="stagingOutcome"
                type="text"
              />
              <UncontrolledTooltip target="stagingOutcomeLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.stagingOutcome" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.active')}
                id="tumor-staging-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.cursor')}
                id="tumor-staging-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.lastUpdated')}
                id="tumor-staging-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.microSec')}
                id="tumor-staging-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorStaging.timestampEntry')}
                id="tumor-staging-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.tumorStaging.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="tumor-staging-recordedBy"
                name="recordedBy"
                data-cy="recordedBy"
                label={translate('tinyMedicRestApp.tumorStaging.recordedBy')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-staging-tumor"
                name="tumor"
                data-cy="tumor"
                label={translate('tinyMedicRestApp.tumorStaging.tumor')}
                type="select"
              >
                <option value="" key="0" />
                {tumors
                  ? tumors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tumor-staging" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TumorStagingUpdate;
